module.exports = __webpack_public_path__ + "img/pause-button.c84a5068.svg";